import _slicedToArray from "@babel/runtime/helpers/slicedToArray";
import PropTypes from 'prop-types';
import React, { useState } from 'react';
import { Collapse } from 'reactstrap';
import StatusBadge from './statusBadge';
import { getCheckStatus } from './qualityAgentHelpers';

// Check item component - simplified summary with expandable message
const CheckItem = _ref => {
  var _check$result, _check$result2, _check$result3;
  let checkId = _ref.checkId,
    check = _ref.check;
  const _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    isOpen = _useState2[0],
    setIsOpen = _useState2[1];
  const status = getCheckStatus(check);
  const hasMessage = !!((_check$result = check.result) !== null && _check$result !== void 0 && _check$result.message);
  return /*#__PURE__*/React.createElement("div", {
    className: "border-bottom py-3"
  }, hasMessage ? /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center",
    style: {
      cursor: 'pointer'
    },
    onClick: () => setIsOpen(!isOpen),
    role: "button",
    tabIndex: 0,
    onKeyDown: e => {
      if (e.key === 'Enter' || e.key === ' ') {
        e.preventDefault();
        setIsOpen(!isOpen);
      }
    }
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3 flex-wrap"
  }, /*#__PURE__*/React.createElement(StatusBadge, {
    status: status
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-medium"
  }, check.description || checkId)), /*#__PURE__*/React.createElement("span", {
    className: "text-muted small"
  }, isOpen ? '▲' : '▼')) : /*#__PURE__*/React.createElement("div", {
    className: "d-flex justify-content-between align-items-center"
  }, /*#__PURE__*/React.createElement("div", {
    className: "d-flex align-items-center gap-3 flex-wrap"
  }, /*#__PURE__*/React.createElement(StatusBadge, {
    status: status
  }), /*#__PURE__*/React.createElement("span", {
    className: "fw-medium"
  }, check.description || checkId))), /*#__PURE__*/React.createElement(Collapse, {
    isOpen: isOpen
  }, /*#__PURE__*/React.createElement("div", {
    className: "mt-3 ms-4 ps-2 border-start"
  }, /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Severity"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium text-capitalize"
  }, ((_check$result2 = check.result) === null || _check$result2 === void 0 ? void 0 : _check$result2.severity) || 'Low')), /*#__PURE__*/React.createElement("div", {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-muted small"
  }, "Details"), /*#__PURE__*/React.createElement("div", {
    className: "fw-medium"
  }, (_check$result3 = check.result) === null || _check$result3 === void 0 ? void 0 : _check$result3.message)))));
};
CheckItem.propTypes = {
  checkId: PropTypes.string.isRequired,
  check: PropTypes.shape({
    description: PropTypes.string,
    result: PropTypes.shape({
      passed: PropTypes.bool,
      message: PropTypes.string,
      severity: PropTypes.string
    })
  }).isRequired
};
export default CheckItem;